import { dynamicschemaData } from '../models/dynamic-schema-data';
import { Injectable } from '@angular/core';


@Injectable()
export class TemplateService {
   public getTemplate() {
     let template = new dynamicschemaData();
      return template;
  }

  public getTemplateText() {
    let template = new dynamicschemaData();
     return JSON.stringify(template.fields);
  }

}
